"use strict";

/**
 * @typedef {string} ArcModelKey - Generated Key using params
 * @export
 */

/**
 * Arc Meta
 * @typedef {object} ArcMetas
 * @property {boolean} loaded
 * @property {boolean} fetching
 * @property {boolean} fetchRequested
 * @property {boolean} valid
 * @property {boolean} saving
 * @property {boolean} deleting
 * @property {boolean} saved
 * @property {number} tries
 * @property {number} start
 * @property {number} end
 */

/**
 * Meta Model
 * @typedef {object} ArcMetaModel
 * @property {ArcMetas} metas
 * @property {ArcModel} model
 * @export
 */

/**
 * Model Data Model
 * @typedef {*} ArcModel
 * @export
 */

exports.unused = {};